import { combineReducers } from "redux";
import userReducer from "./userReducer";
import userSettingsReducer from "./userSettingsReducer";
import userRecordsReducer from "./userRecordsReducer";
import systemResourcesReducer from "./systemResourcesReducer";
import networkErrorsReducer from "./networkErrorsReducer";

export default combineReducers({
  user: userReducer,
  userSettings: userSettingsReducer,
  userRecords: userRecordsReducer,
  systemResources: systemResourcesReducer,
  networkErrors: networkErrorsReducer
});